/* Sticky add-to-cart bar for phones: appears once the main Add to Cart button scrolls out of view.
   The bar itself (with Add to Cart + the Apple Pay / Google Pay / Shop Pay button) is drawn by the product section. */
(function () {
  'use strict';
  var box = document.querySelector('.pdp .js-buy');
  if (!box || !('IntersectionObserver' in window)) return;
  var add = box.querySelector('.js-pdp-add');
  if (!add) return;
  var bar = document.querySelector('.js-satc');
  if (!bar) {
    var h1 = box.querySelector('h1');
    bar = document.createElement('div');
    bar.className = 'satc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="satc__info"><strong></strong><span class="satc__variant"></span><span class="satc__price"></span></div><button type="button" class="satc__btn">Add to Cart</button>';
    bar.querySelector('strong').textContent = h1 ? h1.textContent.trim() : '';
    document.body.appendChild(bar);
  }
  var btn = bar.querySelector('.satc__btn');
  var title = (bar.querySelector('strong') || {}).textContent || '';
  function sync() {
    var sel = box.querySelector('.js-options input:checked');
    var label = sel ? sel.closest('label') : null;
    var name = label ? label.querySelector('strong') : null;
    var v = name ? name.textContent.trim() : '';
    bar.querySelector('.satc__variant').textContent = (v && v !== title.trim()) ? v : '';
    var price = box.querySelector('.js-pdp-price-btn') || box.querySelector('.js-pdp-price');
    bar.querySelector('.satc__price').textContent = price ? price.textContent.trim() : '';
    btn.disabled = add.disabled;
    /* Keep the bar's Apple Pay button on the same pack and gift message as the main one */
    var x = bar.querySelector('.js-xpay');
    if (x) {
      if (sel) x.querySelector('.js-xpay-id').value = sel.value;
      x.hidden = !!(sel && sel.dataset.available === 'false');
      var bg = box.querySelector('.js-xpay-gift'), sg = x.querySelector('.js-xpay-gift');
      if (bg && sg) { sg.disabled = bg.disabled; sg.value = bg.value; }
    }
  }
  sync();
  ['change', 'input'].forEach(function (ev) { box.addEventListener(ev, function () { setTimeout(sync, 0); }); });
  btn.addEventListener('click', function () { add.click(); });
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var past = !e.isIntersecting && e.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', past);
    bar.setAttribute('aria-hidden', String(!past));
  }).observe(add);
})();
